/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreOpsAnswerChoice } from './PreOpsAnswerChoice';
import {
    PreOpsAnswerChoiceFromJSON,
    PreOpsAnswerChoiceFromJSONTyped,
    PreOpsAnswerChoiceToJSON,
    PreOpsAnswerChoiceToJSONTyped,
} from './PreOpsAnswerChoice';

/**
 * 
 * @export
 * @interface PreOpsAnswerCreate
 */
export interface PreOpsAnswerCreate {
    /**
     * The selected choice for the given answer.
     * 
     * This field is bounded by [`PreOpsQuestion.kind`](crate::schemas::pre_ops_questions::PreOpsQuestion#structfield.kind). We enforce this bound by the database trigger `check_pre_ops_answer_choice`.
     * @type {PreOpsAnswerChoice}
     * @memberof PreOpsAnswerCreate
     */
    choice: PreOpsAnswerChoice;
    /**
     * The precise version of the question that's being answered.
     * @type {string}
     * @memberof PreOpsAnswerCreate
     */
    questionVersionId: string;
}



/**
 * Check if a given object implements the PreOpsAnswerCreate interface.
 */
export function instanceOfPreOpsAnswerCreate(value: object): value is PreOpsAnswerCreate {
    if (!('choice' in value) || value['choice'] === undefined) return false;
    if (!('questionVersionId' in value) || value['questionVersionId'] === undefined) return false;
    return true;
}

export function PreOpsAnswerCreateFromJSON(json: any): PreOpsAnswerCreate {
    return PreOpsAnswerCreateFromJSONTyped(json, false);
}

export function PreOpsAnswerCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsAnswerCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'choice': PreOpsAnswerChoiceFromJSON(json['choice']),
        'questionVersionId': json['questionVersionId'],
    };
}

export function PreOpsAnswerCreateToJSON(json: any): PreOpsAnswerCreate {
    return PreOpsAnswerCreateToJSONTyped(json, false);
}

export function PreOpsAnswerCreateToJSONTyped(value?: PreOpsAnswerCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'choice': PreOpsAnswerChoiceToJSON(value['choice']),
        'questionVersionId': value['questionVersionId'],
    };
}

